var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonePaidDays({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7778 1.33334H4.22222C4.01586 1.33334 3.91268 1.33334 3.82569 1.34133C2.85879 1.43008 2.0922 2.23437 2.00761 3.24882C2 3.34009 2 3.44834 2 3.66486V13.5065C2 14.0882 2.7058 14.3351 3.03846 13.8697C3.26923 13.5469 3.73077 13.5469 3.96154 13.8697L4.25 14.2732C4.625 14.7978 5.375 14.7978 5.75 14.2732C6.125 13.7486 6.875 13.7486 7.25 14.2732C7.625 14.7978 8.375 14.7978 8.75 14.2732C9.125 13.7486 9.875 13.7486 10.25 14.2732C10.625 14.7978 11.375 14.7978 11.75 14.2732L12.0385 13.8697C12.2692 13.5469 12.7308 13.5469 12.9615 13.8697C13.2942 14.3351 14 14.0882 14 13.5065V3.66486C14 3.44834 14 3.34009 13.9924 3.24882C13.9078 2.23437 13.1412 1.43008 12.1743 1.34133C12.0873 1.33334 11.9841 1.33334 11.7778 1.33334Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.3333H11",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33343 5.33333L6.66677 7.99999M6.66676 5.33332L9.33341 7.99998",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonePaidDays);
export default __webpack_public_path__ + "static/media/NonePaidDays.09eea7dfa4b6654a93d106fad1252e57.svg";
export { ForwardRef as ReactComponent };